import { atom } from 'jotai';

export const selectedSuggestionAtom = atom<string>('');
export const suggestionsAtom = atom<string[]>([]);
export const userRejectedPaymentsAtom = atom<boolean>(false);

export const resetStoreNameUIAtom = atom(null, (get, set) => {
  set(selectedSuggestionAtom, '');
  set(suggestionsAtom, []);
  set(userRejectedPaymentsAtom, false);
});
